import { makeStyles } from "@material-ui/core";

import { Cooperation } from "../../gardener/gardener.model";
import { LevelIcon } from "./LevelIcon";

const useStyles = makeStyles({
    root: {
        display: "inline-flex",
        alignItems: "center",

        "& > svg": {
            fontSize: "24px",
            marginLeft: "4px",
        },
    },
});

interface LevelIconAndTextProps {
    cooperationLevel: Cooperation["level"];
}

export const LevelIconAndText = (props: LevelIconAndTextProps) => {
    const classes = useStyles();
    const { cooperationLevel } = props;

    const levelText = (() => {
        switch ( cooperationLevel ) {
            case "bronze": return <span>Bronze</span>;
            case "silver": return <span>Sølv</span>;
            case "gold": return <span>Guld</span>;
            case "platin": return <span>Platin</span>;
        }
    })();

    return (
        <div className={classes.root}>
            {levelText}<LevelIcon cooperationLevel={cooperationLevel} />
        </div>
    );
}
